import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        numeroDocumento: "",
        nombres: "",
        empresa: "",
        // 1 = solo personas (clientes, familiares, proveedores y trabajadores);
        // las personas juridicas de tipo entidad (colegios, bancos) se filtran aparte.
        tipoPersonaEntidad: 1,
    },
    results: [],
}

export const personSearchSlice = createSlice({
    name: "personSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        
    },
});

export const { setValue, setResults } = personSearchSlice.actions;
export default personSearchSlice.reducer;
